import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alarmObjType'
})
export class AlarmObjTypePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
